// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/critical.scss
// module id = 71
// module chunks = 1